const PostApiData = async (props) => { 
    const _res = await props._api({
        ...props,
        method: "post",
        endpoint: "/api/apidata",
        param: "",
        data: {
          type: props.type,
          numAtCard: props.numAtCard,
          deviceSN: props.deviceSN,
          productCodeSN: props.productCodeSN,
          shipments: props.shipments,
          insuranceNo: props.insuranceNo,
        },
      });

    return _res;
}

export default PostApiData;